'use client';
import { alpha, Button, Stack, useTheme } from '@mui/material';
import { trackEvent } from '../../../../../utils/trackEvent';
import { TabsProps } from './type';
import getRichTextSummary from '../../../../RichText/getRichTextSummary';

const DesktopTabs = ({ projects, selected, setSelected }: TabsProps) => {
  const theme = useTheme();
  if (projects.length === 1) return null;
  return (
    <Stack
      direction={'row'}
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {projects.map((item, index) => {
        const isSelected = selected === index;
        const color = !isSelected
          ? alpha(theme.palette.text.primary, 0.8)
          : theme.palette.text.primary;
        return (
          <Button
            variant={'text'}
            key={item.id! + index}
            sx={{
              textDecoration: isSelected ? 'underline' : undefined,
              color: color,
            }}
            onClick={() => {
              trackEvent('select_content', {
                content_type: 'general_interaction',
                placement: 'projectCarousel',
                item_id: getRichTextSummary(item.title),
              });
              setSelected(index);
            }}
          >
            {getRichTextSummary(item.title)}
          </Button>
        );
      })}
    </Stack>
  );
};

export default DesktopTabs;
